import { Property } from "@flatfile/api/api";
import { FFValidator } from "src/utils";
import { INTEGER_VALIDATOR } from "./Validators";

export const ActualRecurringBonusFields: Property[] = [
  {
    label: "Actual Rec. Bonus ($)",
    key: "actualRecurringBonus",
    type: "number",
  },
  {
    label: "Actual Rec. Bonus Notes",
    key: "actualRecurringBonusNotes",
    type: "string",
  },
];

export const getActualRecurringBonusValidators = () => [
  FFValidator.regexMatches(
    "actualRecurringBonus",
    RegExp(INTEGER_VALIDATOR),
    "Must be a whole number"
  ),
];
